import ResultMsgPage from '../../views/ResultMsgPage';
import { connect } from 'react-redux';
import { actions } from '../../../state/auth';
import { push } from 'connected-react-router';
import { actions as assessmentactions } from '../../../state/assessment';
const mapStateToProps = (state, ownProps) => ({
  view: ownProps.match.params.view || 'source',
  project: state.shift.project[ownProps.match.params.projectId],
  locale: ownProps.match.params.locale,
  status: state.shift.status,
  reference_id: state.shift.assessment.reference_id
});

const mapDispatchToProps = (dispatch, ownProps) => {
  const { locale } = ownProps.match.params;

  return {
    clickOKHandler: value => {
      // localStorage.clear();
      // sessionStorage.clear();
      // dispatch(actions.logout());
      // // console.log(value);
      dispatch(push(`/${locale}/shift`));
      dispatch(assessmentactions.resetAssessmentStore());// new added
    },

    clickFAQHandler: value => {
      // console.log(value);
      dispatch(push(`/${locale}/faqpage`));
    }
  };
};

const ResultMsgPageComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResultMsgPage);

export default ResultMsgPageComponent;



// WEBPACK FOOTER //
// ./src/components/container/ResultMsgPage/index.js